import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Car_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.32212 8.4749C8.57666 7.04306 9.82152 6 11.2758 6H20.7242C22.1785 6 23.4233 7.04306 23.6779 8.4749L24.8379 15H25C26.6569 15 28 16.3431 28 18V23C28 23.8885 27.6137 24.6868 27 25.2361V27.5C27 28.8807 25.8807 30 24.5 30C23.1196 30 22 28.8813 22 27.5003V26H10V27.5C10 28.8807 8.88071 30 7.5 30C6.11956 30 5 28.8813 5 27.5003V25.2361C4.38625 24.6868 4 23.8885 4 23V18C4 16.3431 5.34315 15 7 15H7.1621L8.32212 8.4749ZM9.19346 15H22.8065L21.7088 8.82497C21.6239 8.34769 21.209 8 20.7242 8H11.2758C10.791 8 10.3761 8.34769 10.2912 8.82497L9.19346 15ZM7 17C6.44772 17 6 17.4477 6 18V23C6 23.5523 6.44772 24 7 24H25C25.5523 24 26 23.5523 26 23V18C26 17.4477 25.5523 17 25 17H7ZM24 26V27.5003C24 27.7762 24.2236 28 24.5 28C24.7761 28 25 27.7761 25 27.5V26H24ZM8 26H7L7 27.5003C7 27.7762 7.22358 28 7.5 28C7.77614 28 8 27.7761 8 27.5V26Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.5 20.25C9.08579 20.25 8.75 20.5858 8.75 21C8.75 21.4142 9.08579 21.75 9.5 21.75C9.91421 21.75 10.25 21.4142 10.25 21C10.25 20.5858 9.91421 20.25 9.5 20.25ZM7.25 21C7.25 19.7574 8.25736 18.75 9.5 18.75C10.7426 18.75 11.75 19.7574 11.75 21C11.75 22.2426 10.7426 23.25 9.5 23.25C8.25736 23.25 7.25 22.2426 7.25 21ZM22.5 20.25C22.0858 20.25 21.75 20.5858 21.75 21C21.75 21.4142 22.0858 21.75 22.5 21.75C22.9142 21.75 23.25 21.4142 23.25 21C23.25 20.5858 22.9142 20.25 22.5 20.25ZM20.25 21C20.25 19.7574 21.2574 18.75 22.5 18.75C23.7426 18.75 24.75 19.7574 24.75 21C24.75 22.2426 23.7426 23.25 22.5 23.25C21.2574 23.25 20.25 22.2426 20.25 21ZM14.25 21C14.25 20.5858 14.5858 20.25 15 20.25H17C17.4142 20.25 17.75 20.5858 17.75 21C17.75 21.4142 17.4142 21.75 17 21.75H15C14.5858 21.75 14.25 21.4142 14.25 21Z"
            />
        </SvgStyled>
    );
};

export default Car_lg;
